import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    router: null,
    windowWidth: 1000,
    pageTransition: "none",
    currentRoute: "",
    showNotes: false,
    largeMusic: false,
    pages: [
      { component: "HomePage", path: "/" },
      { component: "WhoAmI", path: "/intro" },
      { component: "WhoAmI;2", path: "/intro2" },
      { component: "WhoAmI;3", path: "/intro3" },
      { component: "StartingIdea", path: "/idea" },
      { component: "TwinkleTwinkle", path: "/twinkle" },
      { component: "ComplicatedMusic", path: "/complicated" },
      { component: "InitialMotivation", path: "/motivation" },
      { component: "InitialMotivation;2", path: "/motivation2" },
      { component: "InitialMotivation;3", path: "/motivation3" },
      { component: "CanIUse", path: "/caniuse" },
      { component: "CanIUse;2", path: "/caniuse2" },
      { component: "CanIUse;3", path: "/caniuse3" },
      { component: "LearningProcess", path: "/learning" },
      { component: "OverviewFlowChart", path: "/overview", transition: { back: "none" } },
      { component: "EncodeAsAbc", path: "/encode", transition: { back: "none", forward: "none" } },
      { component: "EncodeAsAbc;2", path: "/encode2", transition: { back: "none", forward: "none" } },
      { component: "InitializeObjects", path: "/initialize", transition: { back: "none", forward: "none" } },
      { component: "InitializeObjects;2", path: "/initialize2", transition: { back: "none", forward: "none" } },
      { component: "InitializeObjects;3", path: "/initialize3", transition: { back: "none", forward: "none" } },
      { component: "SoundFont", path: "/soundfont", transition: { back: "none", forward: "none" } },
      { component: "SoundFont;2", path: "/soundfont2", transition: { back: "none", forward: "none" } },
      { component: "SoundFont;3", path: "/soundfont3", transition: { back: "none", forward: "none" } },
      { component: "SoundFont;4", path: "/soundfont4", transition: { back: "none", forward: "none" } },
      { component: "AssembleSound", path: "/assemble", transition: { back: "none", forward: "none" } },
      { component: "AssembleSound;2", path: "/assemble2", transition: { back: "none", forward: "none" } },
      { component: "AssembleSound;3", path: "/assemble3", transition: { back: "none", forward: "none" } },
      { component: "AssembleSound;4", path: "/assemble4", transition: { back: "none", forward: "none" } },
      { component: "AssembleSound;5", path: "/assemble5", transition: { back: "none", forward: "none" } },
      { component: "VisualControls", path: "/visual", transition: { back: "none", forward: "none" } },
      { component: "VisualControls;2", path: "/visual2", transition: { back: "none", forward: "none" } },
      { component: "VisualControls;3", path: "/visual3", transition: { back: "none", forward: "none" } },
      { component: "VisualControls;4", path: "/visual4", transition: { back: "none", forward: "none" } },
      { component: "StartPlaying", path: "/start", transition: { forward: "none" } },
      { component: "StartPlaying;2", path: "/start2", transition: { forward: "none" } },
      { component: "StartPlaying;3", path: "/start3", transition: { forward: "none" } },
      { component: "StartPlaying;4", path: "/start4", transition: { forward: "none" } },
      { component: "StartPlaying;5", path: "/start5", transition: { forward: "none" } },
      { component: "StartPlaying;6", path: "/start6", transition: { forward: "none" } },
      { component: "UserActionInitiated", path: "/user-action" },
      { component: "BrowserConsiderations", path: "/browsers" },
      { component: "PerformanceConcerns", path: "/performance" },
      { component: "PerformanceConcerns;2", path: "/performance2" },
      { component: "LatencyIssues", path: "/latency" },
      { component: "LatencyIssues;2", path: "/latency2" },
      { component: "LatencyIssues;3", path: "/latency3" },
      { component: "DelayDemo", path: "/delay" },
      // { component: "RecordingDetails", path: "/recording" },
      // { component: "RecordingIssues", path: "/recording-issues" },
      { component: "InConclusion", path: "/conclusion" },
      { component: "InConclusion;2", path: "/conclusion2" },
      { component: "InConclusion;3", path: "/conclusion3" },
      { component: "InConclusion;4", path: "/conclusion4" },
    ],
  },
  getters: {
    pageTransition: state => {
      return state.pageTransition;
    },
    showNotes: state => {
      return state.showNotes;
    },
    currentRoute: state => {
      return state.currentRoute;
    },
    windowWidth: state => {
      return state.windowWidth;
    },
    pages: state => {
      return state.pages;
    },
    previousPage: (state, getters) => {
      const index = getters.currentPageNumber;
      if (index <= 0)
        return '404';
      return state.pages[index-1].path;
    },
    nextPage: (state, getters) => {
      const index = getters.currentPageNumber;
      if (index < 0 || index >= state.pages.length-1)
        return '404';
      return state.pages[index+1].path;
    },
    hasPreviousPage: (state, getters) => {
      return getters.previousPage !== '404';
    },
    hasNextPage: (state, getters) => {
      return getters.nextPage !== '404';
    },
    currentPageNumber: state => {
      if (!state.router)
        return 0;
      const currentPage = state.router.currentRoute.fullPath;
      const index = state.pages.findIndex(page => {
        return page.path === currentPage;
      });
      if (index >= 0)
        return index;
      return 0;
    },
    totalPageCount: state => {
      return state.pages.length;
    },
    abcjsOptions: state => {
      const width = Math.max(300, Math.min(state.windowWidth-120, 1400));
      let scale;
      if (!state.largeMusic || width < 740) scale = 1;
      else if (width < 1000) scale = 1.5;
      else scale = 2;
      return {
        add_classes: true,
        staffwidth: width,
        viewportVertical: true,
        scale: scale,
        wrap: {
          minSpacing: 1.8,
          maxSpacing: 2.8,
          preferredMeasuresPerLine: 6
        },
      };
    },
    simpleMusic: () => {
      return `X:1
T:Twinkle, Twinkle
M:4/4
L:1/4
Q:1/4=180
K:Bb
"Bb"BBff|"Eb"gg"Bb"f2|"Eb"ee"Bb"dd|"F7"cc"Bb"B2|]
`;
    },
    simpleMusicAbbrev: () => {
      return `X:1
M:4/4
L:1/4
K:Bb
"Bb"BBff|"Eb"gg"Bb"f2|"Eb"ee"Bb"dd|"F7"cc"Bb"B2|]
`;
    },
    complicatedMusic: () => {
      return `X:1
M:6/8
L:1/16
Q:3/8=70
%%textfont "Avenir, sans-serif" 12
%%staves {(PianoRightHand) (PianoLeftHand)}
V:PianoRightHand
K:Ab clef=treble
!p!C2E2A1G1 F6|!<(!F4G2 !<)!A6|!>(!=A4B2 c2d2!>)!c2|!p!A6 z6|[=a12c12=A12]|B6 G4G2|
A6 E6|[c12=E12]|F1A1G2A2 G6|F6 E3D1F2|!<(!D4B2 A4!<)!E2|!mf![A12F12]|
G2A2B1c1 B6|e4c2 G4A1B1|c4F2 A4e2|[E12c12]|]
V:PianoLeftHand
K:Ab clef=bass
A,4C,2 D,1F,1E,2C,2|=D,4E,1_D,1 C,6|C4B,1C1 A,4C2|[C6F6] z6|F12|B,4C2 B,4E,2|
[A,6F,6] z6|[C12G,12]|A,2B,1C1A,2 E,6|F,12|F,,2A,,2G,,2 A,,4G,,1A,,1|F,,12|
E,,2F,,2B,,2 G,,3A,,1B,,1A,,1|G,,2F,,2A,,2 E,,4F,,2|E,,4A,,2 F,,4E,,2|[E,12C,12A,,12]|]
%%vskip 20
%%center © Gracenotes LLC 2019
`;
    },
    syncTune: () => {
      return `X:1
T:Bill Bailey
C:Hughie Cannon (1902)
M:4/4
L:1/4
Q:1/4=150
K:C
%%MIDI program 105
"C"GA2c|e3/2^d/2eg|GA2c|e4|
GA2c|e2g2|"G7"(gB3-|B4)|
GB2d|fefg|GB2d|f4|
GB2d|g2"G+"a2|"C"(ae3-|e4)|
GA2c|e3/2^d/2eg|GA2c|e3G|
GGce|g2_b2|"F"a4-|a3c|
cc2c|"F#°7"d2c2|"C"gg2a|"A7"e3e|
"D7"ed^cd|"G7"f2e2|"C"c4-|czz2|]
`;
    },
    allNotesOnPiano: () => {
      return `X:1
%%scale .8
%%stretchlast 1
T:All Notes On Piano
M:4/4
L:1/8
K:C clef=bass
A,,,,^A,,,,B,,,,C,,, ^C,,,D,,,^D,,,E,,,|F,,,^F,,,G,,,^G,,, A,,,^A,,,B,,,C,,|^C,,D,,^D,,E,, F,,^F,,G,,^G,,|A,,^A,,B,,C, ^C,D,^D,E,|
K:C clef=treble
F,^F,G,^G, A,^A,B,C|^CD^DE F^FG^G|A^ABc ^cd^de|f^fg^g a^abc'|
^c'd'^d'e' f'^f'g'^g'|a'^a'b'c'' ^c''d''^d''e''|f''^f''g''^g'' a''^a''b''c'''|^c'''4|]`;
    },
    simpleMusicMap: () => {
      return `// <b2>Melody Track</span> (60=middle C)
[
  {<b2>pitch</span>:70, <b2>instrument</span>:"piano", <b2>start</span>:0,    <b2>end</span>:0.242, <b2>volume</span>:64}, 
  {pitch:70, instrument:"piano", start:0.25, end:0.492, volume:64}, 
  {pitch:77, instrument:"piano", start:0.5,  end:0.742, volume:64}, 
  {pitch:77, instrument:"piano", start:0.75, end:0.992, volume:64}, 
  {pitch:79, instrument:"piano", start:1,    end:1.242, volume:64}, 
  {pitch:79, instrument:"piano", start:1.25, end:1.492, volume:64}, 
  {pitch:77, instrument:"piano", start:1.5,  end:1.992, volume:64}, 
  {pitch:75, instrument:"piano", start:2,    end:2.242, volume:64}, 
  {pitch:75, instrument:"piano", start:2.25, end:2.492, volume:64}, 
  {pitch:74, instrument:"piano", start:2.5,  end:2.742, volume:64}, 
  {pitch:74, instrument:"piano", start:2.75, end:2.992, volume:64}, 
  {pitch:72, instrument:"piano", start:3,    end:3.242, volume:64}, 
  {pitch:72, instrument:"piano", start:3.25, end:3.492, volume:64}, 
  {pitch:70, instrument:"piano", start:3.5,  end:3.992, volume:64}
]
// <b2>Rhythm Track</span>
[ 
  {pitch:34, instrument:"piano", start:0,    end:0.125, volume:64}, 
  {pitch:46, instrument:"piano", start:0.25, end:0.375, volume:48}, 
  {pitch:50, instrument:"piano", start:0.25, end:0.375, volume:48}, 
  {pitch:53, instrument:"piano", start:0.25, end:0.375, volume:48}, 
  
  {pitch:29, instrument:"piano", start:0.5,  end:0.625, volume:64}, 
  {pitch:46, instrument:"piano", start:0.75, end:0.875, volume:48}, 
  {pitch:50, instrument:"piano", start:0.75, end:0.875, volume:48}, 
  {pitch:53, instrument:"piano", start:0.75, end:0.875, volume:48}, 
  
  {pitch:39, instrument:"piano", start:1,    end:1.125, volume:64}, 
  {pitch:51, instrument:"piano", start:1.25, end:1.375, volume:48}, 
  {pitch:55, instrument:"piano", start:1.25, end:1.375, volume:48}, 
  {pitch:58, instrument:"piano", start:1.25, end:1.375, volume:48}, 
  
  {pitch:29, instrument:"piano", start:1.5,  end:1.625, volume:64}, 
  {pitch:46, instrument:"piano", start:1.75, end:1.875, volume:48}, 
  {pitch:50, instrument:"piano", start:1.75, end:1.875, volume:48}, 
  {pitch:53, instrument:"piano", start:1.75, end:1.875, volume:48}, 
  
  {pitch:39, instrument:"piano", start:2,    end:2.125, volume:64}, 
  {pitch:51, instrument:"piano", start:2.25, end:2.375, volume:48}, 
  {pitch:55, instrument:"piano", start:2.25, end:2.375, volume:48}, 
  {pitch:58, instrument:"piano", start:2.25, end:2.375, volume:48}, 
  
  {pitch:29, instrument:"piano", start:2.5,  end:2.625, volume:64}, 
  {pitch:46, instrument:"piano", start:2.75, end:2.875, volume:48}, 
  {pitch:50, instrument:"piano", start:2.75, end:2.875, volume:48}, 
  {pitch:53, instrument:"piano", start:2.75, end:2.875, volume:48}, 
  
  {pitch:41, instrument:"piano", start:3,    end:3.125, volume:64}, 
  {pitch:53, instrument:"piano", start:3.25, end:3.375, volume:48}, 
  {pitch:57, instrument:"piano", start:3.25, end:3.375, volume:48}, 
  {pitch:60, instrument:"piano", start:3.25, end:3.375, volume:48}, 
  {pitch:63, instrument:"piano", start:3.25, end:3.375, volume:48}, 
  
  {pitch:29, instrument:"piano", start:3.5,  end:3.625, volume:64}, 
  {pitch:46, instrument:"piano", start:3.75, end:3.875, volume:48}, 
  {pitch:50, instrument:"piano", start:3.75, end:3.875, volume:48}, 
  {pitch:53, instrument:"piano", start:3.75, end:3.875, volume:48}
]`;
    },
  },
  mutations: {
    router(state, payload) {
      state.router = payload;
    },
    showNotes(state, payload) {
      state.showNotes = payload;
    },
    pageTransition(state, payload) {
      state.pageTransition = payload;
    },
    windowSize(state, payload) {
      state.windowWidth = document.body.clientWidth; //payload.width;
    },
    currentRoute(state, payload) {
      state.currentRoute = payload;
    },
    largeMusic(state, payload) {
      state.largeMusic = payload;
    },
  },
  actions: {
    setRouter: (context, payload) => {
      context.commit("router", payload);
    },
    toggleNotes: (context) => {
      context.commit("showNotes", !context.getters.showNotes);
    },
    setTransition: (context, payload) => {
      context.commit("pageTransition", payload.direction);
    },
    setWindowSize: (context, payload) => {
      context.commit("windowSize", payload);
    },
    setLargeMusic: (context, payload) => {
      context.commit("largeMusic", payload);
    },
    setCurrentRoute: (context, payload) => {
      context.commit("currentRoute", payload);
      localStorage.setItem("route", payload);
    },
  },
  modules: {
  }
});
